export { default } from "./InfoBlockMedia";
export * from "./InfoBlockMedia";
